import { Cell } from "gui/grid/cell";
import { Grid } from "gui/grid/grid";
import { Quote } from "gui/quote/quote";
import { SanityQuotes } from "lib/sanity/types";
import { Subtitle } from "gui/subtitle/subtitle";

export const Quotes: React.FC<{
  item: SanityQuotes;
}> = (props) => {
  const id = `aria-${props.item._key}`;

  return (
    <Grid revealOnScroll aria-labelledby={id} gaps>
      <Subtitle text={props.item.title} id={id} />
      {props.item.quotes.map((item) => (
        <Cell key={item._id} span6="lg">
          <Quote item={item} />
        </Cell>
      ))}
    </Grid>
  );
};
